import { PanelItemState } from '@ibiz-template/runtime';

/**
 * 首页空白占位状态
 *
 * @export
 * @class IndexBlankPlaceholderState
 * @extends {PanelItemState}
 */
export class IndexBlankPlaceholderState extends PanelItemState {}
